import React, { useState } from 'react';

import type { Owner } from '../../../@types/Owner';
import { useAdsModal } from '../../../hooks/useAdsModal';
import AdsModal from '../../common/AdsModal/AdsModal';
import MUITable from '../../common/MUITable';
import { formatDpeDetailsFromOwner } from '../utils/formatters';
import CoproLocalOwned from './CoproLocalOwned';
import DpeDetailsPopup from './DpeDetailsPopup';
import OwnerInfos from './OwnerInfos';
import { LastContactInfo } from './PreviousContactList';

export type RefusedTableInteractionKey = 'salesManagerInteractions' | 'rentManagerInteractions';

interface RefusedTableProps {
  data: Owner[];
  interactionKey: RefusedTableInteractionKey;
  totalCount?: number;
  onPageChange?: (page: number, rowsPerPage: number) => void;
  currentPage?: number;
  currentRowsPerPage?: number;
}

const RefusedTable: React.FC<RefusedTableProps> = ({
  data,
  interactionKey,
  totalCount,
  onPageChange,
  currentPage,
  currentRowsPerPage,
}) => {

  const [isDpeDetailsOpen, setIsDpeDetailsOpen] = useState(false);
  const [selectedDpe, setSelectedDpe] = useState<Record<string, unknown> | null>(null);
  const { handleAdsClick, adsModalProps } = useAdsModal();

  const handleDpeDetailsClick = (dpeDetails: Record<string, unknown>) => {
    setSelectedDpe(dpeDetails);
    setIsDpeDetailsOpen(true);
  };

  const getDpeDetails = (owner: Owner): React.ReactNode => {
    return formatDpeDetailsFromOwner(owner, handleDpeDetailsClick, handleAdsClick);
  };

  const tableData = data.map(owner => {
    const interactions = owner[interactionKey];
    return {
      'Propriétaire': <OwnerInfos owner={owner} />,
      'Propriété': <CoproLocalOwned owner={owner} />,
      'Dernier contact': <LastContactInfo owner={owner} />,
      'DPE': getDpeDetails(owner),
      'Motif du refus': interactions && interactions.length > 0
        ? interactions[0].comment || 'Non précisé'
        : 'Non précisé',
    };
  });

  const headers = [
    { title: 'Propriétaire', class: 'w-1/5' },
    { title: 'Propriété', class: 'w-1/5' },
    { title: 'Dernier contact', class: 'w-1/5' },
    { title: 'DPE', class: 'w-1/5' },
    { title: 'Motif du refus', class: 'w-1/5' },
  ];

  return (
    <>
      <MUITable
        data={tableData}
        headers={headers}
        isSearchable={true}
        tableClass="w-full"
        disablePagination={false}
        apiPagination={!!onPageChange}
        totalCount={totalCount}
        onPageChange={onPageChange}
        currentPage={currentPage}
        currentRowsPerPage={currentRowsPerPage}
      />

      {selectedDpe && (
        <DpeDetailsPopup
          isOpen={isDpeDetailsOpen}
          onClose={() => setIsDpeDetailsOpen(false)}
          dpeDetails={selectedDpe}
        />
      )}

      <AdsModal {...adsModalProps} />
    </>
  );
};

export default RefusedTable;
